// Content status constants

export const CONTENT_STATUSES = ['draft', 'pending', 'published', 'private', 'archived'] as const;

export type ContentStatus = (typeof CONTENT_STATUSES)[number];

export const CONTENT_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'pending', label: 'Pending' },
  { value: 'published', label: 'Published' },
  { value: 'archived', label: 'Archived' },
] as const;

// Content type constants

export type ContentType =
  | 'article'
  | 'announcement'
  | 'page'
  | 'post'
  | 'news'
  | 'hub'
  | 'case-study'
  | 'analysis'
  | 'playbook';

export interface ContentTypeConfig {
  label: string;
  color: string;
  description: string;
}

export const CONTENT_TYPE_CONFIG: Record<ContentType, ContentTypeConfig> = {
  article: {
    label: 'Article',
    color: 'bg-blue-100 text-blue-800',
    description: 'A long-form written piece such as a blog post or news article',
  },
  announcement: {
    label: 'Announcement',
    color: 'bg-orange-100 text-orange-800',
    description: 'A short notice or update for your audience',
  },
  page: {
    label: 'Page',
    color: 'bg-purple-100 text-purple-800',
    description: 'A standalone page with custom content',
  },
  hub: {
    label: 'Hub',
    color: 'bg-emerald-100 text-emerald-800',
    description: 'A template hub view',
  },
  post: {
    label: 'Post',
    color: 'bg-green-100 text-green-800',
    description: 'A short social-style update or story',
  },
  news: {
    label: 'News',
    color: 'bg-cyan-100 text-cyan-800',
    description: 'News',
  },
  'case-study': {
    label: 'Case Study',
    color: 'bg-amber-100 text-amber-800',
    description: 'A detailed case study showcasing results and outcomes',
  },
  analysis: {
    label: 'Analysis',
    color: 'bg-indigo-100 text-indigo-800',
    description: 'A structured analysis with workflow-based navigation',
  },
  playbook: {
    label: 'Playbook',
    color: 'bg-orange-100 text-orange-800',
    description: 'An outcome-driven guided execution playbook with timeline and milestones',
  },
} as const;

/** Content types that support the Workflow editor (stored in content.data.workflow) */
export const WORKFLOW_CONTENT_TYPES: ContentType[] = ['case-study', 'analysis'];
